import { colors } from '@atlaskit/theme'
import { ZeraLogo } from '@zera-admin/logo'

import { Flex, FlexContent, FlexFooter } from './Empty.styled'

const EmptyLayout: React.FunctionComponent = ({ children }) => {
  return (
    <Flex>
      <FlexContent>{children}</FlexContent>
      <FlexFooter>
        <ZeraLogo iconColor={colors.N400} size="small" />
      </FlexFooter>
    </Flex>
  )
}

export default EmptyLayout
